import { NumberFormatter } from '@mantine/core';
import { List } from 'src/design/atoms/List';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { CollapsiblePaperSection } from 'src/design/molecules/CollapsiblePaperSection';
import React from 'react';
import { LineGroupingDto } from 'src/api/FiretrolApiClient';

export interface ILineSummaryPanelProps {
  grouping: LineGroupingDto | null | undefined;
}

export const LineSummaryPanel: React.FC<ILineSummaryPanelProps> = ({
  grouping,
}) => {
  if (!grouping) return null;

  return (
    <CollapsiblePaperSection
      title="Line Summary"
      trailing={
        <Text size="xs" c="dimmed">
          {grouping.headGroups.length} head group
          {grouping.headGroups.length !== 1 ? 's' : ''},{' '}
          {grouping.mainlinePipes.length} mainline pipe
          {grouping.mainlinePipes.length !== 1 ? 's' : ''}
        </Text>
      }
    >
      <Stack gap="xs">
        {grouping.quantities.length === 0 ? (
          <Text size="sm" c="dimmed">
            No quantity data available.
          </Text>
        ) : (
          <List size="sm" spacing="xs">
            {grouping.quantities.map((q) => (
              <List.Item key={q.prefix}>
                <Text span fw={600} c="bright">
                  {q.prefix}:
                </Text>{' '}
                <NumberFormatter
                  value={q.quantity}
                  thousandSeparator
                  decimalScale={2}
                />{' '}
                {q.uom}
              </List.Item>
            ))}
          </List>
        )}
      </Stack>
    </CollapsiblePaperSection>
  );
};
